export type BuildVersion = {
  branch: string | null;
  hash: string | null;
  tag: string | null;
  time: string | null;
};

export const getMeta = (name: string): string | null =>
  document.querySelector(`meta[name="${name}"]`)?.getAttribute('content') ??
  null;

export function getWebappBuildVersion(): BuildVersion {
  return {
    tag: getMeta('build-tag'),
    branch: getMeta('build-branch'),
    hash: getMeta('build-hash'),
    time: getMeta('build-time'),
  } as BuildVersion;
}
